function Disclaimer() {
    return (
        <div className="card" style={{ marginTop: 'var(--spacing-xl)', background: 'var(--bg-tertiary)' }}>
            <h3 style={{ color: 'var(--text-primary)', marginBottom: 'var(--spacing-md)' }}>
                ⚠️ Important Disclaimer
            </h3>

            <div style={{ color: 'var(--text-secondary)', lineHeight: '1.8' }}>
                <p>
                    <strong>This calculator is provided for educational and informational purposes only.</strong> The calculations
                    and estimates provided are based on the information you input and certain assumptions about property taxes,
                    insurance rates, and Private Mortgage Insurance (PMI).
                </p>

                <p>
                    <strong>Actual costs may vary.</strong> Property taxes, homeowner insurance premiums, and PMI rates are
                    estimated based on state averages and may not reflect the actual costs in your specific area or for your
                    particular property. We strongly recommend obtaining quotes from insurance providers and verifying property
                    tax rates with your local tax assessor.
                </p>

                <p>
                    <strong>Not financial advice.</strong> This tool should not be considered as financial, legal, or tax advice.
                    The results provided by this calculator do not constitute an offer to lend or a commitment to provide financing.
                    Please consult with qualified financial advisors, legal professionals, and tax experts before making any
                    decisions regarding home financing.
                </p>

                <p>
                    <strong>ARM Loans.</strong> For Adjustable Rate Mortgage (ARM) loans, the interest rate shown is the initial
                    rate only. After the fixed-rate period ends, your interest rate and monthly payment may change based on market
                    conditions and the terms of your loan agreement. The amortization schedule shown assumes the initial rate
                    remains constant, which may not reflect actual future payments.
                </p>

                <p>
                    <strong>Rates subject to change.</strong> Interest rates, property taxes, insurance premiums, and other costs
                    are subject to change without notice. Lender requirements, loan programs, and qualification criteria may vary.
                    Your actual loan terms, interest rate, and monthly payment may differ from the estimates provided here.
                </p>

                <p>
                    <strong>Due diligence required.</strong> Before committing to any mortgage or home purchase, you should:
                </p>
                <ul style={{ marginLeft: 'var(--spacing-lg)', marginBottom: 'var(--spacing-sm)' }}>
                    <li>Obtain pre-approval from a licensed mortgage lender</li>
                    <li>Review all loan documents carefully with legal counsel</li>
                    <li>Verify all costs and fees with your lender</li>
                    <li>Consider your long-term financial goals and ability to make payments</li>
                    <li>Understand all terms and conditions of your mortgage agreement</li>
                </ul>

                <p style={{ marginTop: 'var(--spacing-md)', fontSize: '0.875rem', fontStyle: 'italic' }}>
                    By using this calculator, you acknowledge that you have read and understood this disclaimer and agree that
                    Principal Saver and its creators are not liable for any decisions made based on the information provided by
                    this tool.
                </p>
            </div>
        </div>
    );
}

export default Disclaimer;
